interface TopMenuState {
    selectedMenuPoint:string, 
    isDropdownOpen:boolean,
    isFullscreenEnabled: boolean
}

export const TopMenuStateInitialState:TopMenuState={
    selectedMenuPoint:"Yoda",
    isDropdownOpen:false,
    isFullscreenEnabled: false
}

export function deepCopyTopMenuState(toCopy:TopMenuState) : TopMenuState {
    return {
        selectedMenuPoint:toCopy.selectedMenuPoint, 
        isDropdownOpen:toCopy.isDropdownOpen,
        isFullscreenEnabled: toCopy.isFullscreenEnabled
    }
}